<template>
  <dashboard-modal
    :modal-id="modalId"
    :title="modalTitle"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
  >
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="`/accreditations/process/evaluationTeam/update`"
      >
        <div
          class="row"
          v-if="evaluationList && evaluationList.length > 0"
        >
          <div class="col-12">
            <app-note
              class="pt-2 clearfix"
              :title="$t('Procesos en bloque')"
              content-type="html"
              note-type="note-warning"
              :notes="[
                $t(
                  'Al realizar o no la aprobación de la propuesta de equipo evaluador se efectuará la misma acción para las siguientes evaluaciones o testificaciones'
                ),
              ]"
            />
          </div>
          <br />
          <div class="col-12">
            <table class="table table-sm table-striped">
              <thead>
                <tr>
                  <th scope="col">Expediente</th>
                  <th scope="col">Tipo</th>
                  <th scope="col">Código</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(value, key) in evaluationList" :key="key">
                  <td class="align-middle">
                    {{ value.accreditation_applications.record }}
                  </td>
                  <td class="align-middle">
                    <br />
                    <p v-if="value.type == 'E'">Evaluación</p>
                    <p v-if="value.type == 'T'">Testificación</p>
                  </td>
                  <td class="align-middle">{{ value.code }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="mb-4" v-if="!showOrgProf">
          <div class="alert alert-info alert-dismissible fade show" role="alert">
            <table style="width: 100%;">
              <thead>
                <tr>
                  <th class="text-center" colspan="2">Información para Generar la Proforma</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="width: 23%;"><b>Organismo:</b></td>
                  <td>
                    {{ accApp.organization
                    ? `${accApp.organization.business_name}`
                    : ""
                     }}
                  </td>
                </tr>
                <tr>
                  <td style="width: 23%;"><b>RUC:</b></td>
                  <td>
                    {{ accApp.organization
                    ? `${accApp.organization.taxid}`
                    : ""
                     }}
                  </td>
                </tr>
                <tr>
                  <td style="width: 23%;"><b>Dirección:</b></td>
                  <td>
                    {{ accApp.organization
                    ? `${accApp.organization.address}`
                    : ""
                     }}
                  </td>
                </tr>
                <tr>
                  <td style="width: 23%;"><b>Telefono:</b></td>
                  <td>
                    {{ accApp.delegate_phone
                    ? `${accApp.delegate_phone}`
                    : ""
                     }}
                  </td>
                </tr>
                <tr>
                  <td style="width: 23%;"><b>Email:</b></td>
                  <td>
                    {{ accApp.delegate_email
                    ? `${accApp.delegate_email}`
                    : `${accApp.organization?accApp.organization.email:""}`
                     }}
                  </td>
                </tr>
                <tr>
                  <td style="width: 23%;"><b>Contacto:</b></td>
                  <td>
                    {{ accApp.delegate_name
                    ? `${accApp.delegate_name}`
                    : ""
                     }}
                  </td>
                </tr>
              </tbody>
            </table>
            
          </div>
          <div>
            Cambiar información para generar la Proforma,
                <a
                  :href="`/user/proformadata/${accApp.user_id}`"
                  > Click Aquí
                </a>

          </div>
        </div>

        <div class="mb-4" v-if="showOrgProf">
          <div class="alert alert-info alert-dismissible fade show" role="alert">
            <table style="width: 100%;">
              <thead>
                <tr>
                  <th class="text-center" colspan="2">Información para Generar la Proforma</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="width: 23%;"><b>Organismo:</b></td>
                  <td >
                    {{ orgProforma.business_name
                    ? `${orgProforma.business_name}`
                    : ""
                     }}
                  </td>
                </tr>
                <tr>
                  <td style="width: 23%;"><b>RUC:</b></td>
                  <td>
                    {{ orgProforma.taxid
                    ? `${orgProforma.taxid}`
                    : ""
                     }}
                  </td>
                </tr>
                <tr>
                  <td style="width: 23%;"><b>Dirección:</b></td>
                  <td>
                    {{ orgProforma.address
                    ? `${orgProforma.address}`
                    : ""
                     }}
                  </td>
                </tr>
                <tr>
                  <td style="width: 23%;"><b>Telefono:</b></td>
                  <td>
                    {{ orgProforma.phone
                    ? `${orgProforma.phone}`
                    : ""
                     }}
                  </td>
                </tr>
                <tr>
                  <td style="width: 23%;"><b>Email:</b></td>
                  <td>
                    {{ orgProforma.email
                    ? `${orgProforma.email}`
                    : ""
                     }}
                  </td>
                </tr>
                <tr>
                  <td style="width: 23%;"><b>Contacto:</b></td>
                  <td>
                    {{ orgProforma.legal_representative
                    ? `${orgProforma.legal_representative}`
                    : ""
                     }}
                  </td>
                </tr>
                <tr>
                  <td colspan="2" class="text-center">
                    <button
                      type="submit"
                      class="btn btn-primary"
                      @click.prevent="changeInitial(orgProforma.id)"
                    >
                      {{ "Cambiar a Información Inicial" }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            
          </div>
          <div>
            Cambiar información para generar la Proforma,
                <a
                  :href="`/user/proformadata/${accApp.user_id}`"
                  > Click Aquí
                </a>

          </div>
        </div>

        <div class="row" >
          <div class="col-6" v-if="inputs.request_signed">
            <div class="form-group text-center">
              <p class="card-title m-0">
                <strong>Solicitud de Acreditación</strong>
              </p>
              <br />
              <a
                :href="inputs.request_signed"
                class="btn btn-success"
                target="_blank"
                @click="saveFile(filePath)"
              >
                <app-icon name="file" />
              </a>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group text-center">
              <p class="card-title m-0">
                <strong>Propuesta de Equipo Evaluador</strong>
              </p>
              <br />
              <a :href="fileUrl" class="btn btn-success" target="_blank" @click="saveFile(fileUrlPath)">
                <app-icon name="file" />
              </a>
            </div>
          </div>
        </div>

        <div
          class="
            card card-with-shadow
            border-0
            mb-primary
            justify-content-center
            align-items-center
          "
        >
          <div class="form-group row text-center">
            <label for="inputs_name" class="col-sm-12 mb-0">
              <h5 class="card-title m-0">Aprueba el equipo evaluador?</h5>
              <br />
            </label>
            <app-input
              id="inputs_approved"
              class="col-sm-12"
              type="radio-buttons"
              :list="listOptions"
              @input="clicked"
              v-model="inputs.approved"
              :required="true"
            />
          </div>
        </div>

        <div class="form-group row align-items-center" v-if="!hide">
          <label for="inputs_name" class="col-sm-12 mb-0">
            <h5 class="card-title m-0">
              Justificación de rechazo del Equipo Evaluador
            </h5>
            <br />
          </label>
          <app-input
            id="inputs_observations"
            class="col-sm-12"
            type="textarea"
            v-model="inputs.observations"
            :required="true"
          />
        </div>
        <div class="card card-with-shadow border-0 mb-primary" v-if="!hide">
          <div class="card-body">
            <div class="form-group mb-primary row align-items-center">
              <div class="col-sm-12">
                <h5 class="card-title m-0">
                  Documentación Complementaria
                  <span class="text-danger">Opcional</span>
                </h5>
                <app-input
                  type="file"
                  :label="file"
                  v-model="inputs.attach_rejected"
                  v-on:change="fileChoosen"
                />
                <br />
                <small class="form-text text-muted">Archivo MAX 8MB</small>
              </div>
            </div>
          </div>
        </div>
      </form>
    </template>
  </dashboard-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";
import * as actions from "../../../../apiUrl";

export default {
  name: "ProformaModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    accreditationId: Number,
    evaluationId: Number,
    fileUrl: String,
    fileUrlPath: String,
  },
  data() {
    return {
      preloader: false,
      inputs: {
        observations: null,
        request_signed: null,
      },
      accApp: {},
      orgProforma: {},
      showOrgProf: false,
      filePath: "",
      evaluationList:"",
      hide: true,
      file: "Seleccionar Archivo",
      modalId: "team-id-modal",
      modalTitle: this.$t("add"),
      listOptions: [
        {
          id: "2",
          value: "No",
        },
        {
          id: "1",
          value: "Si",
        },
      ],
    };
  },
  created() {
    this.modalTitle = this.$t("Aceptar u Objetar Equipo");
    this.getInfo();
  },
  methods: {
    getInfo() {
      this.preloader = true;
      let url = `${actions.ACCREDITATION_PROCESS}/accreditation/${this.accreditationId}?evalTestId=${this.evaluationId}`;
      this.axiosGet(url)
        .then((response) => {
          if (
            response.data.evaluationList &&
            response.data.evaluationList.length > 0
          ) {
            this.evaluationList = response.data.evaluationList;
          }

          if (response.status == 200) {
            this.accApp = response.data;
            if (response.data.accreditation_type_id !== 6 && response.data.accreditation_type_id !== 7 && response.data.accreditation_type_id !== 9) {
              this.inputs.request_signed = response.data.request_signed.full_url;
              this.filePath = response.data.request_signed.path;
            }

            let urlProf = `/org/proformadata/showPF?userId=${response.data.user_id}`;
            this.axiosGet(urlProf)
              .then((response) => {
                
                if (response.status == 200) {
                  this.orgProforma = response.data;
                  if (this.orgProforma) {
                    this.showOrgProf = true;
                  }
                }
              })
              .catch(({ error }) => {
                console.log(error);
              })
              .finally(() => {
                this.preloader = false;
              });
          }
        })
        .catch(({ error }) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
    clicked(event) {
      if (this.inputs.approved === "2") {
        this.hide = false;
      } else {
        this.hide = true;
      }
    },
    fileChoosen(event) {
      if (event.target.files[0].size < 8111775) {
        this.file = event.target.files[0].name;
      } else {
        this.$toastr.e("EL archivo PDF no debe exceder los 2MB.");
      }
    },
    submit() {
      this.inputs.accreditation_application_id = this.accreditationId;
      this.inputs.evaluation_id = this.evaluationId;
      let formData = new FormData();
      for (const [key, value] of Object.entries(this.inputs)) {
        formData.append(key, value);
      }
      this.save(formData);
    },
    afterSuccess(response) {
      if (response.status == 200) {
        this.$toastr.s("Registro actualizado exitosamente.");
      }
      this.$hub.$emit("reload-" + this.tableId);
    },
    saveFile(file) {
      let info = {};
      info['accAppId'] = null;
      info['evalTestId'] = this.evaluationId;
      info['path'] = String(file);
      this.$store.dispatch("registerFileLog", info);
    },
    returnPage() {
      window.location.href = `/accreditations/process/evaluationTeam`;
    },
    changeInitial(id) {
      
      let url = `org/proformadata/destroyPF/${id}`;
      this.preloader = true;
      this.axiosDelete(url)
        .then((response) => {
        })
        .catch(({ error }) => {})
        .finally(() => {
          this.returnPage();
          this.preloader = false;
        });
      
    }
  },
};
</script>
